var _path, _path2, _rect, _rect2, _rect3, _path3, _path4, _path5, _path6, _path7, _rect4, _rect5, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWord(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    width: "500px",
    height: "500px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#55a7f9",
    d: "M82,80c0,2.209-1.791,4-4,4H28c-2.209,0-4-1.791-4-4V22c0-2.209,1.791-4,4-4h50c2.209,0,4,1.791,4,4 V80z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#1d1d1b",
    d: "M78,85H28c-2.757,0-5-2.243-5-5V22c0-2.757,2.243-5,5-5h50c2.757,0,5,2.243,5,5v58 C83,82.757,80.757,85,78,85z M28,19c-1.654,0-3,1.346-3,3v58c0,1.654,1.346,3,3,3h50c1.654,0,3-1.346,3-3V22c0-1.654-1.346-3-3-3 H28z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 37,
    height: 16,
    x: 44,
    y: 35,
    fill: "#2d80d3"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 37,
    height: 16,
    x: 44,
    y: 51,
    fill: "#0262b8"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 16,
    x: 25,
    y: 67,
    fill: "#0553a4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#2d80d3",
    d: "M44,64c0,2.209-1.791,4-4,4H13c-2.209,0-4-1.791-4-4V38c0-2.209,1.791-4,4-4h27c2.209,0,4,1.791,4,4 V64z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#1d1d1b",
    d: "M40,69H13c-2.757,0-5-2.243-5-5V38c0-2.757,2.243-5,5-5h27c2.757,0,5,2.243,5,5v26 C45,66.757,42.757,69,40,69z M13,35c-1.654,0-3,1.346-3,3v26c0,1.654,1.346,3,3,3h27c1.654,0,3-1.346,3-3V38c0-1.654-1.346-3-3-3 H13z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#1d1d1b",
    d: "M64,35.5H43c-0.276,0-0.5-0.224-0.5-0.5s0.224-0.5,0.5-0.5h21c0.276,0,0.5,0.224,0.5,0.5 S64.276,35.5,64,35.5z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#1d1d1b",
    d: "M82,35.5h-7c-0.276,0-0.5-0.224-0.5-0.5s0.224-0.5,0.5-0.5h7c0.276,0,0.5,0.224,0.5,0.5 S82.276,35.5,82,35.5z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#1d1d1b",
    d: "M72,35.5h-5c-0.276,0-0.5-0.224-0.5-0.5s0.224-0.5,0.5-0.5h5c0.276,0,0.5,0.224,0.5,0.5 S72.276,35.5,72,35.5z"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 39,
    height: 1,
    x: 43,
    y: 66.5,
    fill: "#1d1d1b"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 1,
    x: 44,
    y: 50.5,
    fill: "#1d1d1b"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M34.402,42.757l-2.821,13.259l-3.127-13.259h-3.991l-3.225,13.669l-2.908-13.669h-3.571 l4.279,18.253h4.293l3.127-14.034l3.129,14.034h4.109l4.279-18.253H34.402z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#472b29",
    d: "M37.971,42.757l-4.277,18.254h-4.109l-3.129-14.034L23.33,61.011h-4.293l-4.279-18.254h3.571 l2.908,13.669l3.225-13.669h3.991l3.127,13.259l2.821-13.259H37.971 M37.971,42h-3.571c-0.357,0-0.666,0.25-0.74,0.599 l-2.119,9.958l-2.352-9.975C29.109,42.241,28.804,42,28.452,42h-3.991c-0.351,0-0.655,0.241-0.737,0.583l-2.451,10.386 l-2.205-10.37C18.994,42.25,18.685,42,18.328,42h-3.571c-0.232,0-0.45,0.106-0.593,0.286c-0.144,0.182-0.197,0.418-0.144,0.643 l4.279,18.253c0.08,0.342,0.386,0.584,0.737,0.584h4.293c0.354,0,0.661-0.247,0.739-0.592l2.388-10.719l2.39,10.719 c0.077,0.347,0.384,0.592,0.739,0.592h4.109c0.351,0,0.657-0.242,0.737-0.584l4.279-18.253c0.053-0.226,0-0.462-0.144-0.643 C38.421,42.106,38.203,42,37.971,42L37.971,42z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWord);
export default __webpack_public_path__ + "static/media/word.ae2a8a633d4d9664fe273d9765422c92.svg";
export { ForwardRef as ReactComponent };